import React, { Component } from 'react';
import {createMarkup} from './Factory'; 
import {PopupboxManager,PopupboxContainer} from 'react-popupbox';

class Publikation extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);	
		this.openPopupbox = this.openPopupbox.bind(this);	
		this.closePopupbox = this.closePopupbox.bind(this);	
	}
	handleClick(){
		let {title,publication_price:price} = this.props;
		this.props.handleClick(title.rendered,price);
	}
	closePopupbox() {
		document.body.classList.remove('no-scroll');
	}
	openPopupbox() {
	  document.body.classList.add('no-scroll');
	  const content = <img alt={this.props.image_data.alt} src={this.props.image_data.image} />
	  PopupboxManager.open({
		content,
		config: {
		  titleBar: {
			enable: true
		  },
		  fadeIn: true,
		  fadeInSpeed: 500
		}
	  })
	}
	render(){		
		let {title,content,publication_price,image_data,publication_active} = this.props;
		const {label_bestellen,label_vergriffen} = this.props.staticData;
		let {image:imgUrl,title:image_title,alt,image_tiny} = image_data;
		let divStyle = {
				backgroundImage: 'url(' + imgUrl + ')',
				backgroundSize: 'contain',
				maxWidth: '100%',
				backgroundPosition: 'center'
		}
		return(
			<article className="pubs-item clearfix">
				<PopupboxContainer onClosed={this.closePopupbox}/>
				<div title={image_title} className="ratio-publication thumb" style={divStyle} onClick={this.openPopupbox}>
					<img src={image_tiny} alt={alt} title={image_title} />
				</div>
				<h1 className="author" dangerouslySetInnerHTML={createMarkup(title.rendered)}></h1>
				<p className="desc" dangerouslySetInnerHTML={createMarkup(content.rendered)}></p>
				<div className="price">
					{publication_price}<br/>
					{(publication_active!=="0") ?
					<a onClick={this.handleClick} className="open-overlay">{label_bestellen}</a>
					: <a className="open-overlay no-hover">{label_vergriffen}</a>
					}
				</div>
			</article>
		)
	}	
}
export default Publikation;


// WEBPACK FOOTER //
// ./src/components/Publikation.js